import { useEffect } from 'react';
import { navigate } from '@/hooks/useRoute';
import { useStore } from '@/context/StoreContext';
import './RingSizeGuidePage.css';

const sizes = [
  { mm:'14.1', us:'3', uk:'F' },
  { mm:'14.9', us:'4', uk:'H' },
  { mm:'15.7', us:'5', uk:'J' },
  { mm:'16.5', us:'6', uk:'L' },
  { mm:'17.3', us:'7', uk:'N' },
  { mm:'18.1', us:'8', uk:'P' },
  { mm:'19.0', us:'9', uk:'R' },
  { mm:'19.8', us:'10', uk:'T' },
  { mm:'20.6', us:'11', uk:'V' },
  { mm:'21.4', us:'12', uk:'X' },
  { mm:'22.2', us:'13', uk:'Z' },
];

const faqs = [
  ['האם יש הבדל בין טבעת דקה לעבה?', 'כן. טבעת רחבה או עבה מרגישה לעיתים הדוקה יותר על האצבע, ולכן במקרים רבים שוקלים לעלות מעט במידה לעומת טבעת דקה מאוד.'],
  ['האם טבעת אירוסין נמדדת כמו כל טבעת אחרת?', 'שיטת המדידה זהה, אבל יש משמעות לרוחב הטבעת, למבנה הראש של האבן ולכך שלעיתים עונדים לצדה גם טבעת נישואין.'],
  ['האם אפשר לשנות מידה אחר כך?', 'ברוב המקרים כן, אבל זה תלוי במבנה הטבעת, בסוג המתכת ובמיקום האבנים. לכן תמיד עדיף למדוד נכון מראש ולקבל ייעוץ אם יש ספק.'],
  ['האם יש הבדל בין ימין לשמאל?', 'לעיתים כן. אצל אנשים רבים היד הדומיננטית מעט רחבה יותר, ולכן המידה יכולה להשתנות בין הקמיצה ביד שמאל לזו שביד ימין.'],
  ['מהי מידה נפוצה בישראל?', 'אצל נשים רבות טווח מידות נפוץ נע סביב 52–54 במידה אירופית, אך אין תחליף למדידה אישית של האצבע או של טבעת קיימת.'],
  ['מתי כדאי למדוד?', 'רצוי למדוד כאשר טמפרטורת הגוף והסביבה רגילות. בקיץ האצבעות נוטות להתנפח מעט ובחורף הן עשויות להיות צרות יותר.'],
];

function go(path:string){ navigate(path); }

export function RingSizeGuidePage(){
  const { cms } = useStore();

  useEffect(()=>{
    const previousTitle=document.title;
    document.title='מדריך מידות טבעת | MIELLEY';
    return ()=>{ document.title=previousTitle; };
  },[]);

  const whatsappText = encodeURIComponent('שלום MIELLEY, אשמח לעזרה בהתאמת מידת טבעת.');
  const whatsapp=`https://wa.me/${cms.site.whatsapp}?text=${whatsappText}`;

  return <>
    <nav className="breadcrumbs container">
      <a href="/" onClick={e=>{e.preventDefault();go('/')}}>בית</a>
      <span>›</span>
      <strong>מדריך מידות טבעת</strong>
    </nav>

    <main className="size-guide-page" dir="rtl">
      <section className="sg-hero">
        <div className="container sg-hero-grid">
          <div className="sg-hero-copy">
            <span className="sg-overline">FIND YOUR RING SIZE</span>
            <h1>איך מוצאים מידת טבעת<br/>בצורה מדויקת ונוחה?</h1>
            <p>בין אם מודדים טבעת קיימת או את האצבע עצמה — בנינו עבורך מדריך ברור, אלגנטי וקל לשימוש, כדי לבחור את המידה בביטחון.</p>
            <div className="sg-actions">
              <a className="btn gold" href="#measure-by-ring">מדידה לפי טבעת קיימת</a>
              <a className="btn secondary" href="#measure-by-finger">מדידה על האצבע</a>
            </div>
            <div className="sg-highlights">
              <div><b>2</b><span>שיטות מדידה פשוטות</span></div>
              <div><b>11</b><span>מידות בטבלת ההשוואה</span></div>
              <div><b>MIELLEY</b><span>ליווי אישי אם יש התלבטות</span></div>
            </div>
          </div>
          <div className="sg-hero-visual" aria-hidden="true">
            <div className="sg-card-main">
              <div className="sg-ring-diagram"><span className="ring-hole"/></div>
              <div className="sg-line"/><div className="sg-mm">17.3 mm</div>
            </div>
            <div className="sg-card-side">
              <span>QUICK NOTE</span>
              <strong>מדדו פעמיים · בדקו פעם אחת</strong>
              <small>אם אתם בין שתי מידות — לרוב עדיף לבדוק את מבנה הטבעת ולקבל ייעוץ.</small>
            </div>
          </div>
        </div>
      </section>

      <section className="sg-methods section">
        <div className="container">
          <header className="sg-section-head">
            <span>02 · שתי דרכים נוחות למדוד</span>
            <h2>אפשר למדוד לפי טבעת קיימת או ישירות על האצבע</h2>
            <p>בדף המקור שממנו ביקשת להשריש את התוכן מופיעות שתי שיטות עיקריות: מדידה של קוטר פנימי של טבעת קיימת, ומדידה של היקף האצבע באמצעות פס נייר או חוט.【turn789104view0†L244-L276】</p>
          </header>

          <div className="sg-method-grid">
            <article id="measure-by-ring">
              <span>METHOD 01</span>
              <h3>מדידה לפי טבעת קיימת</h3>
              <ol>
                <li>בחרו טבעת שיושבת טוב על האצבע הרצויה.</li>
                <li>מדדו את <strong>הקוטר הפנימי</strong> שלה במילימטרים.</li>
                <li>השוו את הנתון לטבלת המידות בהמשך העמוד.</li>
              </ol>
              <div className="sg-mini-visual ring"><div/></div>
            </article>
            <article id="measure-by-finger">
              <span>METHOD 02</span>
              <h3>מדידה על האצבע</h3>
              <ol>
                <li>לפפו פס נייר דק סביב האצבע במקום שבו תישב הטבעת.</li>
                <li>סמנו את נקודת המפגש.</li>
                <li>פתחו את הפס ומדדו את האורך, ואז השוו לטבלת המידות.</li>
              </ol>
              <div className="sg-mini-visual finger"><div/><i/></div>
            </article>
          </div>
        </div>
      </section>

      <section className="sg-table-wrap">
        <div className="container">
          <header className="sg-section-head compact">
            <span>03 · RING SIZE TABLE</span>
            <h2>טבלת מידות שימושית להשוואה</h2>
            <p>בטבלת ההשוואה של JoolMe מופיעים קטרים פנימיים בין 14.1 ל־22.2 מ״מ, עם התאמה למידות US/Canada ולמידות UK/Australia.【turn789104view0†L246-L260】</p>
          </header>

          <div className="sg-size-table">
            <div className="sg-row head"><span>קוטר פנימי (מ״מ)</span><span>US / Canada</span><span>UK / Australia</span></div>
            {sizes.map(row=><div className="sg-row" key={row.mm}><span>{row.mm}</span><span>{row.us}</span><span>{row.uk}</span></div>)}
          </div>

          <div className="sg-note-grid">
            <article>
              <b>מה אם אני בין שתי מידות?</b>
              <p>אם אתם מתלבטים בין שתי מידות, בדקו את רוחב הטבעת: טבעת רחבה מרגישה לרוב הדוקה יותר מטבעת דקה.</p>
            </article>
            <article>
              <b>יד ימין מול יד שמאל</b>
              <p>ייתכן הבדל קטן בין הידיים, במיוחד אם יש יד דומיננטית ברורה. תמיד עדיף למדוד את האצבע שבה תיענד הטבעת בפועל.</p>
            </article>
            <article>
              <b>עונות השנה</b>
              <p>בימים חמים האצבעות עלולות להיות מעט נפוחות יותר. מומלץ למדוד במצב נייטרלי, לא מיד אחרי פעילות או חום קיצוני.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="sg-tips section">
        <div className="container sg-tips-grid">
          <div>
            <span className="sg-overline">MIELLEY TIPS</span>
            <h2>טיפים קטנים שעושים הבדל גדול במדידה</h2>
          </div>
          <div className="sg-tips-list">
            <div><b>01</b><p>מדדו לפחות פעמיים — ובשעה שונה ביום — כדי לוודא שהמידה יציבה.</p></div>
            <div><b>02</b><p>אם הטבעת מיועדת להפתעה, עדיף למדוד טבעת קיימת שנענדת על אותה אצבע.</p></div>
            <div><b>03</b><p>בטבעות מעוצבות, רחבות או משובצות לכל ההיקף, כדאי לוודא התאמה עוד יותר בזהירות.</p></div>
            <div><b>04</b><p>אם יש ספק — אנחנו כאן ללוות ולבדוק יחד איתכם לפני הזמנה.</p></div>
          </div>
        </div>
      </section>

      <section className="sg-faq section">
        <div className="container sg-faq-grid">
          <div className="sg-faq-title">
            <span className="sg-overline">FAQ</span>
            <h2>שאלות נפוצות על מידות טבעת</h2>
            <p>בדף המקור מופיעות גם שאלות נפוצות על הבדלים בין טבעות דקות לעבות, שינוי מידה, הבדל בין הידיים, מידה נפוצה בישראל ועונות השנה.【turn789104view0†L294-L328】</p>
          </div>
          <div className="sg-faq-list">
            {faqs.map(([q,a],i)=><details key={q} open={i===0}>
              <summary>{q}<span>+</span></summary>
              <p>{a}</p>
            </details>)}
          </div>
        </div>
      </section>

      <section className="sg-final">
        <div className="container sg-final-grid">
          <div>
            <span>NEED HELP CHOOSING?</span>
            <h2>עדיין לא בטוחים במידה?</h2>
            <p>אנחנו יכולים לעזור לכם לבדוק יחד את המידה הנכונה, להסביר על התאמה לפי סוג הטבעת ולהפוך את הבחירה לפשוטה יותר.</p>
          </div>
          <div className="sg-final-actions">
            <a className="btn light" href={whatsapp} target="_blank" rel="noreferrer">שליחה ב־WhatsApp</a>
            <a className="btn outline" href="/appointments" onClick={e=>{e.preventDefault();go('/appointments')}}>תיאום פגישה</a>
            <a className="sg-text-link" href="/contact" onClick={e=>{e.preventDefault();go('/contact')}}>ליצירת קשר ←</a>
          </div>
        </div>
      </section>
    </main>
  </>;
}
